import { toast } from "react-toastify"
import { apiConstants } from "../apiConstant"
import compileErrors from "../compileErorrs"
import { serviceCallWithoutAuth } from "../serviceCall"
import { setLoading, setUserInvoiceDetails } from "../../feature/getInvoiceByEmailSlice"

export const getInvoiceUserDetailsApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        dispatch(setLoading(true))

        serviceCallWithoutAuth({
            url: `${apiConstants.GET_INVOICE_BY_EMAIL.VERIFY_TOKEN}/?token=${data.token}`,
            method: 'get',
        })
            .then((response) => {
                dispatch(setLoading(false));
                callback && callback(response)
            })
            .catch((error) => {
                dispatch(setLoading(false))
                toast.error(compileErrors(error.response.data.error))
                errorCallBack && errorCallBack(error.response)
            })
    }
}
